/* import __COLOCATED_TEMPLATE__ from './installation-instructions.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export interface Args {
  isComplete: boolean;
  salesforceConfiguration?: SalesforceConfiguration;
  openInstallLink: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const SalesforceCopilotInstallationInstructions = templateOnlyComponent<Signature>();
export default SalesforceCopilotInstallationInstructions;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::InstallationInstructions': typeof SalesforceCopilotInstallationInstructions;
  }
}
